/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Unit_BottleInputs */

const vi_agri_unit_bottle = /** @type {(inputs: Agri_Unit_BottleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chai`)
};

/**

* @param {Agri_Unit_BottleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_unit_bottle = /** @type {((inputs?: Agri_Unit_BottleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Unit_BottleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_unit_bottle(inputs)
});